export default __webpack_public_path__ + "static/center-ru-cc059cd932090b59f496ad1d9afe1b9c.webp";